// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/rectangle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/rectangle-disabled.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-menu-item {
  flex-direction: row;
  display: flex;
  margin-top: 30px;
  flex-direction: row;
  display: flex;
  margin-top: 30px;
}
.onboarding-menu-index {
  display: flex;
  box-sizing: border-box;
  display: flex;
  box-sizing: border-box;

  position: relative;
  width: 40px;
  height: 40px;
  /* left: 30px; */
  /* top: 66px; */
  position: relative;
  width: 40px;
  height: 40px;
  /* left: 30px; */
  /* top: 66px; */

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  justify-content: center;
}
.onboarding-menu-index-text {
  position: absolute;
  width: 12px;
  height: 29px;
  /* left: 44px; need dis
    cussion*/
  /* top: 171px; */
  /* justify-self: center; */
  /* align-self: center; */
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  /* identical to box height */
  position: absolute;
  width: 12px;
  height: 29px;
  /* left: 44px; need dis
    cussion*/
  /* top: 171px; */
  /* justify-self: center; */
  /* align-self: center; */
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  /* identical to box height */

  text-transform: capitalize;
  text-transform: capitalize;

  color: var(--primary-color);
  color: var(--primary-color);
}
.onboarding-menu-title-desc {
  position: absolute;
  width: 140px;
  height: 38px;
  /* left: 80px; */
  /* top: 67px; */
  flex-direction: column;
  display: flex;
  text-align: left;
  margin-left: 60px;
  position: absolute;
  width: 140px;
  height: 38px;
  /* left: 80px; */
  /* top: 67px; */
  flex-direction: column;
  display: flex;
  text-align: left;
  margin-left: 60px;
}
.onboarding-menu-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--primary-color);
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--primary-color);
}
.onboarding-menu-description {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400; /*need discussion*/
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--text--color);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400; /*need discussion*/
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--text--color);
}
.subscription-plan-item {
  box-sizing: border-box;
  width: 300px;
  height: 100px;
  margin-top: 20px;
  background: var(--background-white);
  border: 1px solid var(--line-color);
  border-radius: 10px;
  margin-left: 37px;
}
.subscription-plan-title {
  width: 100%;
  height: 22px;
  /* left: 329.67px; */
  /* top: 201px; */
  margin-left: 11.3px;
  /* margin-top: 15px; */

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  text-transform: capitalize;

  color: var(--text-color);
}
.subscription-plan-title-radio {
  display: flex;
  flex-direction: row;
  margin: auto;
  padding: 15px;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  margin: auto;
  padding: 15px;
  align-items: flex-start;
}
.subscription-plan-title-desc {
  text-align: left;
  flex-direction: column;
  text-align: left;
  flex-direction: column;
}
.subscription-radio {
  margin-top: 4px;
  width: 13.33px;
  height: 13.33px;
  border-color: var(--radio-button-color);
  accent-color: var(--primary-color);
  margin-top: 4px;
  width: 13.33px;
  height: 13.33px;
  border-color: var(--radio-button-color);
  accent-color: var(--primary-color);
}
.onborading-container {
  display: flex;
  flex-direction: row;
  /* padding-top: 100px; */
  /* display: flex;
  flex-direction: row; */
  /* padding-top: 100px; */
  height: 89%;
}
.onboarding-side-menu {
  width: 20%;
  height: 100%;
  /* height: 668px; */
  /* top:100px; */
  left: 0px;
  position: relative;
  background-color: #ffffff;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 30px;
  border-right: 1px solid var(--line-color);
  width: 20%;
  /* height: 668px; */
  /* top:100px; */
  left: 0px;
  position: relative;
  background-color: #ffffff;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 30px;
}
.onboarding-content {
  margin: 20px;
  margin-top: 0;
  width: 80%;
  /* max-height: 60vh;
    overflow-y: auto; */
  margin: 20px;
  margin-top: 0;
  width: 80%;
  /* max-height: 60vh;
    overflow-y: auto; */
}
.onboarding-title {
  /* text-align: left;
  /* text-align: left;
    display: flex;
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 30px; */
  position: absolute;
  width: 114px;
  height: 24px;
  left: 30px;
  top: 22px;
  line-height: 24.2px;
  text-transform: capitalize;
  color: #001a11;
  margin-bottom: 20px;
  position: absolute;
  width: 114px;
  height: 24px;
  left: 30px;
  top: 22px;
  line-height: 24.2px;
  text-transform: capitalize;
  color: #001a11;
  margin-bottom: 20px;
}
.onboarding-step-container {
  display: flex;
  /* flex-direction: row; */
  justify-content: flex-start;
  text-align: left;
  display: flex;
  /* flex-direction: row; */
  justify-content: flex-start;
  text-align: left;
  height: 100%;
}
.choose-plan {
  font-size: 20px;
  font-weight: 500;
  font-size: 20px;
  font-weight: 500;
}
.onboarding-step-title {
  /* position: absolute; */
  /* width: px; */
  height: 24px;
  /* left: 285px; */
  /* top: 122px; */
  margin-top: 22px;
  /* margin-left: 35px; */
  margin-bottom: 9px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-transform: capitalize;
  /* position: absolute; */
  /* width: px; */
  height: 24px;
  /* left: 285px; */
  /* top: 122px; */
  margin-top: 22px;
  /* margin-left: 35px; */
  margin-bottom: 9px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-transform: capitalize;

  color: var(--text-color);
  display: flex;
  color: var(--text-color);
  display: flex;
}
.plan-details-tooltip {
  box-sizing: border-box;

  position: absolute;
  width: 650px;
  height: 340px;
  /* left: 595.75px; */
  /* top: 186px; */

  background: var(--background-white);
  border: 1px solid var(--primary-color);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin-left: 50px;
  margin-top: 22px;
}
/* .plan-details-tooltip::after {
    content: "";
    position: absolute;
    margin-top: 30px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--primary-color) transparent transparent transparent;
  } */
.onboarding-step-items-container {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
}
.onboarding-step-items-container .onboarding-step-header-container {
  margin-left: 37px;
}
.onboarding-step-items {
  display: flex;
  flex-direction: row;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  height: 100%;
  overflow-y: auto;
}
.subscription-plan-detail-info {
  width: 495px;
  height: 38px;
  margin-left: 26.2px;
  margin-top: 9px;
  width: 495px;
  height: 38px;
  margin-left: 26.2px;
  margin-top: 9px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: var(--black-text);
  color: var(--black-text);
}
.subscription-keypoints {
  display: flex;
  flex-direction: row;
  /* width: 37px; */
  height: 17px;
  margin-left: 26.25px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  /* width: 37px; */
  height: 17px;
  margin-left: 26.25px;
  margin-bottom: 30px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  /* font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px; */
  /* identical to box height */

  color: var(--black-text);
  /* color: var(--black-text); */
}
.keypoint {
  margin-left: 9px;
  /* font-size: 14px; */
  /* margin-left: 9px; */
  /* font-size: 14px; */
}
.onboarding-menu-index-disabled {
  display: flex;
  box-sizing: border-box;

  position: relative;
  width: 40px;
  height: 40px;
  /* left: 30px; */
  /* top: 66px; */

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  justify-content: center;
  display: flex;
  box-sizing: border-box;

  position: relative;
  width: 40px;
  height: 40px;
  /* left: 30px; */
  /* top: 66px; */

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  justify-content: center;
}
.onboarding-menu-index-disabled {
  font-size: 24px;
  font-weight: 600;
  color: #acacac;
  font-size: 24px;
  font-weight: 600;
  color: #acacac;
}
.onboarding-menu-title-disabled {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--disabled-text-color);
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--disabled-text-color);
}
.onboarding-menu-description-disabled {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400; /*need discussion*/
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--disabled-text-color);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400; /*need discussion*/
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--disabled-text-color);
}

.footer-buttons {
  display: flex;
  justify-self: flex-end;
  margin-top: 50px;
  justify-content: flex-start;
  gap: 21px;
  margin-left: 35px;
  display: flex;
  justify-self: flex-end;
  margin-top: 50px;
  justify-content: flex-start;
  gap: 21px;
  margin-left: 35px;
}
.menu-items {
  margin-top: 66px;
  margin-top: 66px;
}
.onboarding-step-description {
  /* position: absolute; */
  /* width: 337px; */
  height: 17px;
  /* left: 285px; */
  /* top: 152px; */
  /* margin-left: 35px; */
  margin-top: 6px;
  line-height: 17px;
  color: var(--black-text);
  /* position: absolute; */
  /* width: 337px; */
  height: 17px;
  /* left: 285px; */
  /* top: 152px; */
  /* margin-left: 35px; */
  margin-top: 6px;
  line-height: 17px;
  color: var(--black-text);
}
.step-info-icon {
  /* position: absolute;
  /* position: absolute;
    top: 1.67px;
    left: 1.67px;

    background: var(--disabled-text-color);
    width: 16.67px;
    height: 16.67px; */
  font-size: 16px;
  display: flex;
  align-items: center;
  color: var(--disabled-text-color);
  font-size: 16px;
  display: flex;
  align-items: center;
  color: var(--disabled-text-color);
}
.active-plan {
  border: 1px solid var(--primary-color);
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--primary-color);
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.1);
}
.onboarding-step-detail-description {
  margin-left: 10px;
  margin-top: 8px;
  font-family: "Inter";
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  color: var(--black-text);
  word-break: break-all;
}
.subscription-plan-tooltip-title {
  width: 100%;
  height: 22px;
  /* left: 329.67px; */
  /* top: 201px; */
  margin-left: 26.2px;
  margin-top: 15px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  text-transform: capitalize;

  color: var(--text-color);
}
.completed-step-img {
  bottom: 0;
  right: 0;
  position: absolute;
  bottom: 0;
  right: 0;
  position: absolute;
}
.participation-value-container {
  margin-top: 20px;
  margin-left: 35px;
  margin-top: 20px;
  margin-left: 35px;
}
.participation-radio-item {
  accent-color: var(--primary-color);
  accent-color: var(--primary-color);
}
.input-radio-label-checked {
  margin-bottom: 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--text-color);
  margin-left: 10px;
  margin-bottom: 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--text-color);
  margin-left: 10px;
}

.input-radio-label {
  margin-bottom: 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--text-color);
  margin-left: 10px;
  margin-bottom: 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: var(--text-color);
  margin-left: 10px;
}
.input-simulator-testData {
  box-sizing: border-box;
  height: 50px;
  margin-bottom: 20px !important;
  background: #ffffff;
  border: 1px solid #c6cbd1;
  border-radius: 5px;
}
.input-simulator-testData{
    box-sizing: border-box;
height: 50px;
margin-bottom: 20px !important;
background: #FFFFFF;
border: 1px solid #C6CBD1;
border-radius: 5px;
}
.ant-upload-drag:hover {
  border-color: #009966 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/onboardingStyles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;;EAEtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;;EAEf,yDAA0D;EAC1D,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yDAA0D;EAC1D,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;YACU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;YACU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,0BAA0B;EAC1B,0BAA0B;;EAE1B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB,EAAE,kBAAkB;EACpC,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB,EAAE,kBAAkB;EACpC,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;;EAEtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,0BAA0B;;EAE1B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB;wBACsB;EACtB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV;uBACqB;EACrB,YAAY;EACZ,aAAa;EACb,UAAU;EACV;uBACqB;AACvB;AACA;EACE;;;;;0BAKwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;;EAE1B,wBAAwB;EACxB,aAAa;EACb,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,sBAAsB;;EAEtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;;EAEhB,mCAAmC;EACnC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;KAQK;AACL;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;;EAEf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;;EAEnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B;;;;sBAIoB;EACpB,4BAA4B;;EAE5B,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;;EAEtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;;EAEf,yDAAmE;EACnE,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;;EAEtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;;EAEf,yDAAmE;EACnE,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB,EAAE,kBAAkB;EACpC,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB,EAAE,kBAAkB;EACpC,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE;;;;;;;sBAOoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,sCAAsC;EACtC,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;;EAEhB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,0BAA0B;;EAE1B,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;IACI,sBAAsB;AAC1B,YAAY;AACZ,8BAA8B;AAC9B,mBAAmB;AACnB,yBAAyB;AACzB,kBAAkB;AAClB;AACA;EACE,gCAAgC;AAClC","sourcesContent":[".onboarding-menu-item {\n  flex-direction: row;\n  display: flex;\n  margin-top: 30px;\n  flex-direction: row;\n  display: flex;\n  margin-top: 30px;\n}\n.onboarding-menu-index {\n  display: flex;\n  box-sizing: border-box;\n  display: flex;\n  box-sizing: border-box;\n\n  position: relative;\n  width: 40px;\n  height: 40px;\n  /* left: 30px; */\n  /* top: 66px; */\n  position: relative;\n  width: 40px;\n  height: 40px;\n  /* left: 30px; */\n  /* top: 66px; */\n\n  background-image: url(\"../../assets/images/rectangle.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  align-items: center;\n  justify-content: center;\n  background-image: url(\"../../assets/images/rectangle.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  align-items: center;\n  justify-content: center;\n}\n.onboarding-menu-index-text {\n  position: absolute;\n  width: 12px;\n  height: 29px;\n  /* left: 44px; need dis\n    cussion*/\n  /* top: 171px; */\n  /* justify-self: center; */\n  /* align-self: center; */\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 29px;\n  /* identical to box height */\n  position: absolute;\n  width: 12px;\n  height: 29px;\n  /* left: 44px; need dis\n    cussion*/\n  /* top: 171px; */\n  /* justify-self: center; */\n  /* align-self: center; */\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 29px;\n  /* identical to box height */\n\n  text-transform: capitalize;\n  text-transform: capitalize;\n\n  color: var(--primary-color);\n  color: var(--primary-color);\n}\n.onboarding-menu-title-desc {\n  position: absolute;\n  width: 140px;\n  height: 38px;\n  /* left: 80px; */\n  /* top: 67px; */\n  flex-direction: column;\n  display: flex;\n  text-align: left;\n  margin-left: 60px;\n  position: absolute;\n  width: 140px;\n  height: 38px;\n  /* left: 80px; */\n  /* top: 67px; */\n  flex-direction: column;\n  display: flex;\n  text-align: left;\n  margin-left: 60px;\n}\n.onboarding-menu-title {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--primary-color);\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--primary-color);\n}\n.onboarding-menu-description {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400; /*need discussion*/\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--text--color);\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400; /*need discussion*/\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--text--color);\n}\n.subscription-plan-item {\n  box-sizing: border-box;\n  width: 300px;\n  height: 100px;\n  margin-top: 20px;\n  background: var(--background-white);\n  border: 1px solid var(--line-color);\n  border-radius: 10px;\n  margin-left: 37px;\n}\n.subscription-plan-title {\n  width: 100%;\n  height: 22px;\n  /* left: 329.67px; */\n  /* top: 201px; */\n  margin-left: 11.3px;\n  /* margin-top: 15px; */\n\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  /* identical to box height */\n\n  text-transform: capitalize;\n\n  color: var(--text-color);\n}\n.subscription-plan-title-radio {\n  display: flex;\n  flex-direction: row;\n  margin: auto;\n  padding: 15px;\n  align-items: flex-start;\n  display: flex;\n  flex-direction: row;\n  margin: auto;\n  padding: 15px;\n  align-items: flex-start;\n}\n.subscription-plan-title-desc {\n  text-align: left;\n  flex-direction: column;\n  text-align: left;\n  flex-direction: column;\n}\n.subscription-radio {\n  margin-top: 4px;\n  width: 13.33px;\n  height: 13.33px;\n  border-color: var(--radio-button-color);\n  accent-color: var(--primary-color);\n  margin-top: 4px;\n  width: 13.33px;\n  height: 13.33px;\n  border-color: var(--radio-button-color);\n  accent-color: var(--primary-color);\n}\n.onborading-container {\n  display: flex;\n  flex-direction: row;\n  /* padding-top: 100px; */\n  /* display: flex;\n  flex-direction: row; */\n  /* padding-top: 100px; */\n  height: 89%;\n}\n.onboarding-side-menu {\n  width: 20%;\n  height: 100%;\n  /* height: 668px; */\n  /* top:100px; */\n  left: 0px;\n  position: relative;\n  background-color: #ffffff;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding-left: 30px;\n  border-right: 1px solid var(--line-color);\n  width: 20%;\n  /* height: 668px; */\n  /* top:100px; */\n  left: 0px;\n  position: relative;\n  background-color: #ffffff;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding-left: 30px;\n}\n.onboarding-content {\n  margin: 20px;\n  margin-top: 0;\n  width: 80%;\n  /* max-height: 60vh;\n    overflow-y: auto; */\n  margin: 20px;\n  margin-top: 0;\n  width: 80%;\n  /* max-height: 60vh;\n    overflow-y: auto; */\n}\n.onboarding-title {\n  /* text-align: left;\n  /* text-align: left;\n    display: flex;\n    font-weight: 500;\n    font-size: 20px;\n    margin-bottom: 30px; */\n  position: absolute;\n  width: 114px;\n  height: 24px;\n  left: 30px;\n  top: 22px;\n  line-height: 24.2px;\n  text-transform: capitalize;\n  color: #001a11;\n  margin-bottom: 20px;\n  position: absolute;\n  width: 114px;\n  height: 24px;\n  left: 30px;\n  top: 22px;\n  line-height: 24.2px;\n  text-transform: capitalize;\n  color: #001a11;\n  margin-bottom: 20px;\n}\n.onboarding-step-container {\n  display: flex;\n  /* flex-direction: row; */\n  justify-content: flex-start;\n  text-align: left;\n  display: flex;\n  /* flex-direction: row; */\n  justify-content: flex-start;\n  text-align: left;\n  height: 100%;\n}\n.choose-plan {\n  font-size: 20px;\n  font-weight: 500;\n  font-size: 20px;\n  font-weight: 500;\n}\n.onboarding-step-title {\n  /* position: absolute; */\n  /* width: px; */\n  height: 24px;\n  /* left: 285px; */\n  /* top: 122px; */\n  margin-top: 22px;\n  /* margin-left: 35px; */\n  margin-bottom: 9px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  text-transform: capitalize;\n  /* position: absolute; */\n  /* width: px; */\n  height: 24px;\n  /* left: 285px; */\n  /* top: 122px; */\n  margin-top: 22px;\n  /* margin-left: 35px; */\n  margin-bottom: 9px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  text-transform: capitalize;\n\n  color: var(--text-color);\n  display: flex;\n  color: var(--text-color);\n  display: flex;\n}\n.plan-details-tooltip {\n  box-sizing: border-box;\n\n  position: absolute;\n  width: 650px;\n  height: 340px;\n  /* left: 595.75px; */\n  /* top: 186px; */\n\n  background: var(--background-white);\n  border: 1px solid var(--primary-color);\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  margin-left: 50px;\n  margin-top: 22px;\n}\n/* .plan-details-tooltip::after {\n    content: \"\";\n    position: absolute;\n    margin-top: 30px;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: var(--primary-color) transparent transparent transparent;\n  } */\n.onboarding-step-items-container {\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  flex-direction: column;\n}\n.onboarding-step-items-container .onboarding-step-header-container {\n  margin-left: 37px;\n}\n.onboarding-step-items {\n  display: flex;\n  flex-direction: row;\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n  height: 100%;\n  overflow-y: auto;\n}\n.subscription-plan-detail-info {\n  width: 495px;\n  height: 38px;\n  margin-left: 26.2px;\n  margin-top: 9px;\n  width: 495px;\n  height: 38px;\n  margin-left: 26.2px;\n  margin-top: 9px;\n\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n\n  color: var(--black-text);\n  color: var(--black-text);\n}\n.subscription-keypoints {\n  display: flex;\n  flex-direction: row;\n  /* width: 37px; */\n  height: 17px;\n  margin-left: 26.25px;\n  margin-top: 10px;\n  display: flex;\n  flex-direction: row;\n  /* width: 37px; */\n  height: 17px;\n  margin-left: 26.25px;\n  margin-bottom: 30px;\n\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  /* identical to box height */\n  /* font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px; */\n  /* identical to box height */\n\n  color: var(--black-text);\n  /* color: var(--black-text); */\n}\n.keypoint {\n  margin-left: 9px;\n  /* font-size: 14px; */\n  /* margin-left: 9px; */\n  /* font-size: 14px; */\n}\n.onboarding-menu-index-disabled {\n  display: flex;\n  box-sizing: border-box;\n\n  position: relative;\n  width: 40px;\n  height: 40px;\n  /* left: 30px; */\n  /* top: 66px; */\n\n  background-image: url(\"../../assets/images/rectangle-disabled.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  box-sizing: border-box;\n\n  position: relative;\n  width: 40px;\n  height: 40px;\n  /* left: 30px; */\n  /* top: 66px; */\n\n  background-image: url(\"../../assets/images/rectangle-disabled.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  align-items: center;\n  justify-content: center;\n}\n.onboarding-menu-index-disabled {\n  font-size: 24px;\n  font-weight: 600;\n  color: #acacac;\n  font-size: 24px;\n  font-weight: 600;\n  color: #acacac;\n}\n.onboarding-menu-title-disabled {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--disabled-text-color);\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--disabled-text-color);\n}\n.onboarding-menu-description-disabled {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400; /*need discussion*/\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--disabled-text-color);\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400; /*need discussion*/\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--disabled-text-color);\n}\n\n.footer-buttons {\n  display: flex;\n  justify-self: flex-end;\n  margin-top: 50px;\n  justify-content: flex-start;\n  gap: 21px;\n  margin-left: 35px;\n  display: flex;\n  justify-self: flex-end;\n  margin-top: 50px;\n  justify-content: flex-start;\n  gap: 21px;\n  margin-left: 35px;\n}\n.menu-items {\n  margin-top: 66px;\n  margin-top: 66px;\n}\n.onboarding-step-description {\n  /* position: absolute; */\n  /* width: 337px; */\n  height: 17px;\n  /* left: 285px; */\n  /* top: 152px; */\n  /* margin-left: 35px; */\n  margin-top: 6px;\n  line-height: 17px;\n  color: var(--black-text);\n  /* position: absolute; */\n  /* width: 337px; */\n  height: 17px;\n  /* left: 285px; */\n  /* top: 152px; */\n  /* margin-left: 35px; */\n  margin-top: 6px;\n  line-height: 17px;\n  color: var(--black-text);\n}\n.step-info-icon {\n  /* position: absolute;\n  /* position: absolute;\n    top: 1.67px;\n    left: 1.67px;\n\n    background: var(--disabled-text-color);\n    width: 16.67px;\n    height: 16.67px; */\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  color: var(--disabled-text-color);\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  color: var(--disabled-text-color);\n}\n.active-plan {\n  border: 1px solid var(--primary-color);\n  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--primary-color);\n  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.1);\n}\n.onboarding-step-detail-description {\n  margin-left: 10px;\n  margin-top: 8px;\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  /* identical to box height */\n  color: var(--black-text);\n  word-break: break-all;\n}\n.subscription-plan-tooltip-title {\n  width: 100%;\n  height: 22px;\n  /* left: 329.67px; */\n  /* top: 201px; */\n  margin-left: 26.2px;\n  margin-top: 15px;\n\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  /* identical to box height */\n\n  text-transform: capitalize;\n\n  color: var(--text-color);\n}\n.completed-step-img {\n  bottom: 0;\n  right: 0;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  position: absolute;\n}\n.participation-value-container {\n  margin-top: 20px;\n  margin-left: 35px;\n  margin-top: 20px;\n  margin-left: 35px;\n}\n.participation-radio-item {\n  accent-color: var(--primary-color);\n  accent-color: var(--primary-color);\n}\n.input-radio-label-checked {\n  margin-bottom: 10px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  margin-left: 10px;\n  margin-bottom: 10px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  margin-left: 10px;\n}\n\n.input-radio-label {\n  margin-bottom: 10px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  margin-left: 10px;\n  margin-bottom: 10px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 19px;\n  text-transform: capitalize;\n  color: var(--text-color);\n  margin-left: 10px;\n}\n.input-simulator-testData {\n  box-sizing: border-box;\n  height: 50px;\n  margin-bottom: 20px !important;\n  background: #ffffff;\n  border: 1px solid #c6cbd1;\n  border-radius: 5px;\n}\n.input-simulator-testData{\n    box-sizing: border-box;\nheight: 50px;\nmargin-bottom: 20px !important;\nbackground: #FFFFFF;\nborder: 1px solid #C6CBD1;\nborder-radius: 5px;\n}\n.ant-upload-drag:hover {\n  border-color: #009966 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
